var $041a8a2796a43a59$exports = {};
$041a8a2796a43a59$exports = {
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`
};


export {$041a8a2796a43a59$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
